// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jMjG","option":"styles_option__qUt5u","selected":"styles_selected__2FPjO"};